/**
 * carrier-service and partner-management-service both match the origin country case-insensitively,
 * so `gb` and `GB` are one answer. Uppercase before the value reaches a query key or a request, and
 * treat blank as absent: a blank `originCountry` parameter is not an error upstream, it silently
 * falls back to the non-resolved service method definition.
 */
export const normalizeOriginCountry = (originCountry?: string | null) => originCountry?.trim().toUpperCase() ?? '';
